/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsAlignBottom: {
  name: 'align-bottom';
  data: string;
} = {
  name: 'align-bottom',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.5 1a.5.5 0 0 0-1 0v9.793L5.354 8.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.793V1ZM2 14.5a.5.5 0 0 0 0 1h12a.5.5 0 0 0 0-1H2Z" fill="currentColor"/></svg>`,
};
